module.exports = __webpack_public_path__ + "static/media/april-dino-cleaned.52aaf712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/april-dino-cleaned.jpg
// module id = 240
// module chunks = 1